/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairhumidityactualsetpoint4Inputs */



/**
* | output |
* | --- |
* | "Supply air actual humidity setpoint" |
*
* @param {Ahu_History_Key_Supplyairhumidityactualsetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairhumidityactualsetpoint4 = /** @type {((inputs?: Ahu_History_Key_Supplyairhumidityactualsetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairhumidityactualsetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air actual humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle humidité air soufflé")
});
export { ahu_history_key_supplyairhumidityactualsetpoint4 as "ahu_history_key_supplyAirHumidityActualSetpoint" }